import { BaseSelectDropDown } from "../BaseSelectDropDown";

const createSelectColumnFilter =
  (options) =>
  ({ value, header, handleFilterSet }) =>
    (
      <BaseSelectDropDown
        value={value}
        header={header}
        options={options}
        includeAllOption
        handleFilterSet={handleFilterSet}
        multiple={true}
      />
    );

const createSelectColumnEditor =
  (options) =>
  ({ value, onBlur }) =>
    (
      <BaseSelectDropDown
        value={value}
        onBlur={onBlur}
        options={options}
        isEditing
      />
    );


export { createSelectColumnFilter, createSelectColumnEditor };